export enum PublicProfileContextType {
  Profile = 'profile',
  Collector = 'collector',
  Manufacturer = 'manufacturer',
}
